var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Accordion, AccordionBody, AccordionHeader, Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, Tile, TileGroup, Typography, } from '@one-thd/sui-atomic-components';
import { DateRangeCalendar } from '@one-thd/sui-date-pickers';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { DateRanges } from '../../../utils/DateRanges';
import { getWindow } from '../../../utils/general';
import { OrderFilterInput } from './OrderFilterInput';
var dateTileOptions = [
    { value: 'last30Days', label: 'Last 30 Days' },
    { value: 'last90Days', label: 'Last 90 Days' },
    { value: 'last6Months', label: 'Last 6 Months' },
    { value: 'thisYear', label: new Date().getFullYear().toString() },
    { value: 'lastYear', label: (new Date().getFullYear() - 1).toString() },
    { value: 'twoYearsPrior', label: (new Date().getFullYear() - 2).toString() },
    {
        value: 'threeYearsPrior',
        label: (new Date().getFullYear() - 3).toString(),
    },
    { value: 'fourYearsPrior', label: (new Date().getFullYear() - 4).toString() },
    { value: 'fiveYearsPrior', label: (new Date().getFullYear() - 5).toString() },
    { value: 'sixYearsPrior', label: (new Date().getFullYear() - 6).toString() },
];
var userTileOptions = function (username) { return [
    { value: 'allOrders', label: 'Everyone' },
    { value: 'myOrders', label: "".concat(username !== null && username !== void 0 ? username : '', " (Just Me)") },
]; };
var parseDateToString = function (date) {
    var _a = date ? date.split('-').map(Number) : [0, 0, 0], year = _a[0], month = _a[1], day = _a[2];
    var monthString = month < 10 ? "0".concat(month) : "".concat(month);
    var dayString = day < 10 ? "0".concat(day) : "".concat(day);
    return "".concat(monthString, "/").concat(dayString, "/").concat(year);
};
export var OrderFilterDrawer = function (_a) {
    var isDrawerOpen = _a.isDrawerOpen, setIsDrawerOpen = _a.setIsDrawerOpen, dateFilterDot = _a.dateFilterDot, setDateFilterDot = _a.setDateFilterDot;
    var username = useThdCustomer().username;
    var _b = usePurchaseHistoryContext(), dateSelectorValue = _b.dateSelectorValue, pHRequest = _b.pHRequest, setDateSelectorValue = _b.setDateSelectorValue, setPHRequest = _b.setPHRequest, setAlertState = _b.setAlertState;
    var _c = useState({
        userView: (pHRequest === null || pHRequest === void 0 ? void 0 : pHRequest.resultsFilter) || 'allOrders',
        customDateUsed: false,
        showCalendar: false,
        invalidStartDate: false,
        invalidEndDate: false,
    }), filterSettings = _c[0], setFilterSettings = _c[1];
    var _d = useState({
        selectedDate: dateSelectorValue,
        startDate: null,
        endDate: null,
    }), dateSettings = _d[0], setDateSettings = _d[1];
    var maxDate = DateTime.now().startOf('day').toString();
    var minDate = DateTime.now()
        .minus({ months: 84 })
        .startOf('day')
        .toString();
    var closeFilterDrawer = function () {
        setIsDrawerOpen(false);
    };
    var onDateSelect = function (_event, date) {
        var _a, _b, _c, _d;
        if (date) {
            setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { customDateUsed: false })); });
            setDateSettings(function (prevState) { return (__assign(__assign({}, prevState), { selectedDate: date })); });
            var startDateStr_1 = ((_b = DateRanges === null || DateRanges === void 0 ? void 0 : DateRanges[(_a = date) !== null && _a !== void 0 ? _a : '']) === null || _b === void 0 ? void 0 : _b.startDate) || '';
            var endDateStr_1 = ((_d = DateRanges === null || DateRanges === void 0 ? void 0 : DateRanges[(_c = date) !== null && _c !== void 0 ? _c : '']) === null || _d === void 0 ? void 0 : _d.endDate) || '';
            var newStartDate_1 = parseDateToString(startDateStr_1);
            var newEndDate_1 = parseDateToString(endDateStr_1);
            setDateSettings(function (prevState) { return (__assign(__assign({}, prevState), { startDate: startDateStr_1 ? newStartDate_1 : null, endDate: endDateStr_1 ? newEndDate_1 : null })); });
        }
    };
    var handleUserViewChange = function () {
        var _a;
        setPHRequest(function (prevState) {
            var _a;
            return __assign(__assign({}, prevState), { resultsFilter: (_a = filterSettings.userView) !== null && _a !== void 0 ? _a : undefined });
        });
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('PHFilter', JSON.stringify(__assign(__assign({}, dateSettings), filterSettings)));
        setDateFilterDot(function (prevState) { return (__assign(__assign({}, prevState), { user: true })); });
        closeFilterDrawer();
    };
    var modifyDateFormat = function (startDate, endDate) {
        var modifiedStartDate = startDate === null || startDate === void 0 ? void 0 : startDate.toString().split('/');
        var modifiedEndDate = endDate === null || endDate === void 0 ? void 0 : endDate.toString().split('/');
        var newStartDate = modifiedStartDate && modifiedStartDate.length === 3
            ? "".concat(modifiedStartDate[2], "-").concat(modifiedStartDate[0], "-").concat(modifiedStartDate[1])
            : '';
        var newEndDate = modifiedEndDate && modifiedEndDate.length === 3
            ? "".concat(modifiedEndDate[2], "-").concat(modifiedEndDate[0], "-").concat(modifiedEndDate[1])
            : '';
        return [newStartDate, newEndDate];
    };
    var handleDateViewChange = function () {
        var _a;
        var _b = modifyDateFormat(dateSettings.startDate, dateSettings.endDate), newStartDate = _b[0], newEndDate = _b[1];
        setDateSelectorValue(dateSettings.selectedDate ||
            'last6Months');
        setPHRequest(function (prevState) { return (__assign(__assign({}, prevState), { startDate: dateSettings.startDate ? newStartDate !== null && newStartDate !== void 0 ? newStartDate : '' : '', endDate: dateSettings.endDate ? newEndDate !== null && newEndDate !== void 0 ? newEndDate : '' : '', pageNumber: 1 })); });
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('PHFilter', JSON.stringify(__assign(__assign({}, dateSettings), filterSettings)));
        setDateFilterDot(function (prevState) { return (__assign(__assign({}, prevState), { date: true })); });
        closeFilterDrawer();
    };
    return (React.createElement(Drawer, { open: isDrawerOpen, onClose: closeFilterDrawer, style: { zIndex: 2000000009 } },
        filterSettings.showCalendar ? (React.createElement(DrawerHeader, { title: "Custom Range", onBack: function () {
                return setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { showCalendar: false })); });
            }, onClose: closeFilterDrawer })) : (React.createElement(DrawerHeader, { title: "Filter", onClose: closeFilterDrawer })),
        React.createElement(DrawerBody, null, filterSettings.showCalendar ? (React.createElement("div", null,
            React.createElement(DateRangeCalendar, { minDate: minDate, maxDate: maxDate, value: {
                    start: dateSettings.startDate || '',
                    end: dateSettings.endDate || '',
                }, onChange: function (_event, value) {
                    setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { customDateUsed: true })); });
                    var modifyStartDate = value.start.split('T')[0];
                    var modifyEndDate = value.end.split('T')[0];
                    var newStartDate = parseDateToString(modifyStartDate);
                    var newEndDate = parseDateToString(modifyEndDate);
                    setDateSettings(function (prevState) { return (__assign(__assign({}, prevState), { startDate: newStartDate, endDate: newEndDate })); });
                } }))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sui-relative sui-border-b-1 sui-border-solid sui-border-strong" },
                dateFilterDot.user && (React.createElement("div", { style: {
                        position: 'absolute',
                        top: '30px',
                        left: '40px',
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: 'rgb(249,99,2)',
                        marginLeft: '8px',
                        zIndex: 100,
                    } })),
                React.createElement(Accordion, { noBorders: true, defaultExpanded: true },
                    React.createElement(AccordionHeader, { "aria-controls": "accordion1-content" }, "User"),
                    React.createElement(AccordionBody, null,
                        React.createElement("div", { className: "sui-mb-[12px]" },
                            React.createElement(TileGroup, { value: filterSettings.userView, onChange: function (_event, value) {
                                    if (value) {
                                        setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { userView: value })); });
                                    }
                                }, "aria-label": "date filter", orientation: "vertical" }, userTileOptions(username).map(function (option) { return (React.createElement(Tile, { key: option.value, value: option.value, "aria-label": "grid view" },
                                React.createElement(Typography, { className: "sui-mr-auto" }, option.label))); })))))),
            React.createElement("div", { className: "sui-relative sui-pt-[14px]" },
                dateFilterDot.date && (React.createElement("div", { style: {
                        position: 'absolute',
                        top: '17px',
                        left: '40px',
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: 'rgb(249,99,2)',
                        marginLeft: '8px',
                        zIndex: 100,
                    } })),
                React.createElement(Accordion, { noBorders: true, defaultExpanded: true },
                    React.createElement(AccordionHeader, { "aria-controls": "accordion1-content" }, "Date"),
                    React.createElement(AccordionBody, null,
                        React.createElement("div", { className: "sui-mb-[20px]" },
                            React.createElement(Typography, { weight: "bold", className: "sui-mb-[4px]" }, "Enter a custom range:"),
                            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-[12px] sui-w-full sui-items-center" },
                                React.createElement(OrderFilterInput, { name: "Start date", dateType: "startDate", dateSettings: dateSettings, setDateSettings: setDateSettings, setFilterSettings: setFilterSettings }),
                                React.createElement(OrderFilterInput, { name: "End date", dateType: "endDate", dateSettings: dateSettings, setDateSettings: setDateSettings, setFilterSettings: setFilterSettings }))),
                        React.createElement("div", { className: "sui-mb-[12px]" },
                            React.createElement(Typography, { weight: "bold", style: { marginBottom: '8px' } }, "Select a range:"),
                            React.createElement(TileGroup, { value: dateSettings.selectedDate, onChange: onDateSelect, "aria-label": "date filter", orientation: "vertical" }, dateTileOptions.map(function (option, key) { return (React.createElement(Tile, { key: key, value: option.value, "aria-label": "list view" },
                                React.createElement(Typography, { className: "sui-mr-auto" }, option.label))); }))))))))),
        filterSettings.showCalendar ? (React.createElement(DrawerFooter, null,
            React.createElement(Button, { variant: "primary", fullWidth: true, disabled: !dateSettings.startDate || !dateSettings.endDate, onClick: function () {
                    return setFilterSettings(function (prevState) { return (__assign(__assign({}, prevState), { showCalendar: false })); });
                } }, "Apply"))) : (React.createElement(DrawerFooter, null,
            React.createElement(Button, { variant: "primary", fullWidth: true, onClick: function () {
                    if (filterSettings.userView !== pHRequest.resultsFilter) {
                        handleUserViewChange();
                        return;
                    }
                    setAlertState(null);
                    handleDateViewChange();
                } }, "View Results")))));
};
